module.exports = __webpack_public_path__ + "media/images/items/static-3-8f1e89373de1274fe9c616efe74c7c28.jpg";